import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useListPayment from "../../controllers/useListPayment";
// import PropTypes from "prop-types";
import Table from "../../core/pagination/datatable";
import PropTypes from "prop-types";
import useDeletePayment from "../../controllers/useDeletePayment";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import moment from "moment";

const Showpayment = ({ customerId, onEdit, refetchCustomers }) => {
  const { payments, total, loading, handlePageChange, refetch } =
    useListPayment(customerId);
  const { handleDeletePayment, loading: deleteLoading } =
    useDeletePayment(refetch, refetchCustomers);

  useEffect(() => {
    const handleModalOpen = async () => {
      console.log("Modal opened");
      try {
        await refetch(); 
        refetchCustomers();
      } catch (error) {
        console.error("Error during refetch:", error);
      }
    };
    const modalElement = document.getElementById("showpayment");
    if (modalElement) {
      modalElement.addEventListener("shown.bs.modal", handleModalOpen);
    }
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("shown.bs.modal", handleModalOpen);
      }
    };
  }, [refetch, refetchCustomers]);

  const columns = [
    {
      title: "Name",
      dataIndex: "full_name",
      sorter: (a, b) =>
        a.customer.full_name.length - b.customer.full_name.length,
      render: (text, record) => record.customer.full_name,
    },
    {
      title: "Amount",
      dataIndex: "received_amount",
      sorter: (a, b) => a.received_amount.length - b.received_amount.length,
      render: (received_amount) => `$${received_amount}`,
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      render: (text) => moment(text).format("DD-MM-YYYY"),
      sorter: (a, b) => new Date(a.payment_date) - new Date(b.payment_date),
    },
    { title: "Type", dataIndex: "paying_type" },
    { title: "Description", dataIndex: "description" },
    {
      title: "Status",
      dataIndex: "is_reverted",
      render: (text, record) => {
        console.log("Record", record);
        return (
          <span
            className={`badge ${
              record?.is_reverted == false
                ? "badge-linesuccess"
                : "badge-linedanger"
            }`}
          >
            {record?.is_reverted == false ? "Succeed" : "Reverted"}
          </span>
        );
      },
      sorter: (a, b) => a.is_reverted.length - b.is_reverted.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-3 p-2"
              // to="#"
              // data-bs-toggle="modal"
              // data-bs-target="#editpayment"
              onClick={() => onEdit(record)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => showConfirmationAlert(record)}
            >
              <i
                data-feather="trash-2"
                className={`feather-trash-2 ${deleteLoading ? "disabled" : ""}`}
              ></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletePayment(record.id);
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  return (
    <div
      className="modal fade"
      id="showpayment"
      tabIndex={-1}
      aria-labelledby="showpayment"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered stock-adjust-modal"
        style={{ maxWidth: "70%" }}
      >
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Show Payments</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="modal-body-table total-orders">
                      <div className="table-responsive">
                        <Table
                          total={total}
                          loading={loading}
                          columns={columns}
                          onPageChange={handlePageChange}
                          dataSource={payments || []}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Showpayment.propTypes = {
  customerId: PropTypes.any.isRequired,
  onEdit: PropTypes.func.isRequired,
  refetchCustomers: PropTypes.func,
};

export default Showpayment;
